import { MatDialog } from '@angular/material/dialog';
import { Injectable } from '@angular/core';
import { ApiService } from 'app/shared/apis/api.service';
import { BaseService } from 'app/core/services/base.service';
import { DoctorModel } from 'app/models/doctor.model';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DoctorService extends BaseService<DoctorModel> {
    constructor(api: ApiService, _matDialog: MatDialog) {
        super(api, _matDialog, 'doctor');
    }

    getDoctor(userId: number): Observable<DoctorModel> {
        return this.api.getSub(`${this.endpoint}/${userId}`);
    }

    updateDoctor(userId: number, doctor: Partial<DoctorModel>): Observable<DoctorModel> {
        return this.api.putSub(`${this.endpoint}/${userId}`, doctor);
    }
}
